import Script from "next/script";

const ContactUsSchema = () => {
    var json_ld = {
        "@context": "https://schema.org/",
        "@type": "WebPage",
        "description": "This webpage describes what the company offers to our clients including the key points applied in our workflow.",
        "name": "About Us Page",
        "url": `${process.env.NEXT_PUBLIC_HOME_URL}/aboutus`,
    };

    const productJsonId = {
        __html: JSON.stringify(json_ld),
    };
    
    return (
        <Script
            type="application/ld+json"
            dangerouslySetInnerHTML={productJsonId}
            id="product-jsonld"
            key="product-jsonld"
        />
    );
};

export default ContactUsSchema;
